export const fixLink = (link: string) => {
    let newLink = link;
    if (link.length !== 0 && link.indexOf('https://') === -1 && link.indexOf('http://') === -1) {
        newLink = `https://${link}`;
    }

    return newLink;
};
